<div class="d-flex flex-column" *ngIf="profileComplete">
	<div class="mx-auto">
		<div class="display-4">Thank you. Your profile has been updated.</div>
	</div>
</div>
<div class="d-flex flex-column" *ngIf="!profileComplete">
	<div class="mx-auto">
		<div class="display-6">Setup your payment profile for {{ venueName }}</div>
	</div>
	<div class="mx-auto">
		<div class="card m-4">
			<div class="d-flex">
				<div class="display-6 ms-1 mt-2 mb-1">Billing Contact</div>
			</div>
			<p-divider></p-divider>
			<div class="item-med">
				The billing contact is the primary person that we'll be working with on billing questions and changes. This is also the person that will receive
				monthly statements and invoices.
			</div>
			<form #billingContactForm="ngForm">
				<div class="p-grid">
					<div class="p-col-12 p-md-6">
						<span class="p-float-label mt-4">
							<input
								pInputText
								#billingContactFirstName
								name="billingContactFirstName"
								type="text"
								class="w-100"
								[(ngModel)]="paymentProfile.fw1__First_Name__c"
								[formControl]="billingContactFirstNameControl"
							/>
							<label for="billingContactFirstName">First Name</label>
						</span>
					</div>
					<div class="p-col-12 p-md-6">
						<span class="p-float-label mt-4">
							<input
								pInputText
								#billingContactLastName
								name="billingContactLastName"
								type="text"
								class="w-100"
								[(ngModel)]="paymentProfile.fw1__Last_Name__c"
								[formControl]="billingContactLastNameControl"
							/>
							<label for="billingContactLastName">Last Name</label>
						</span>
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col-12 p-md-6">
						<span class="p-float-label mt-4">
							<p-inputMask
								#billingContactPhoneInput
								name="billingContactPhoneInput"
								[(ngModel)]="paymentProfile.fw1__Phone__c"
								mask="(999) 999-9999"
								[formControl]="billingContactPhoneControl"
								styleClass="w-100"
							></p-inputMask>
							<label for="billingContactPhoneInput">Phone number</label>
						</span>
					</div>
					<div class="p-col-12 p-md-6">
						<span class="p-float-label mt-4">
							<input
								pInputText
								#billingContactEmailInput
								name="billingContactEmailInput"
								type="text"
								[(ngModel)]="paymentProfile.fw1__Email__c"
								[formControl]="billingContactEmailControl"
								class="w-100"
							/>
							<label for="billingContactEmailInput">Email address</label>
						</span>
					</div>
				</div>
			</form>
		</div>
		<div class="card m-4">
			<div class="d-flex">
				<div class="display-6 ms-1 mt-2 mb-1">Banking Information</div>
			</div>
			<p-divider></p-divider>
			<div class="item-med">
				Please provide the banking information that you would like to use for monthly payments.
				<fa-icon [icon]="['far', 'circle-info']" (click)="bankingInfoDisclaimer.toggle($event)"></fa-icon>
			</div>
			<form #bankingInformationForm="ngForm">
				<div class="p-grid">
					<div class="p-col-12">
						<span class="p-float-label mt-4">
							<input
								pInputText
								#bankingInformationBankName
								name="bankingInformationBankName"
								type="text"
								[(ngModel)]="paymentProfile.Bank_Name__c"
								[formControl]="bankingBankNameControl"
								class="w-100"
							/>
							<label for="bankingInformationBankName">Bank name</label>
						</span>
					</div>
				</div>
				<div class="p-grid">
					<div class="p-col-12 p-md-6">
						<span class="p-float-label mt-4">
							<p-inputMask
								#bankingInformationRoutingNumber
								name="bankingInformationRoutingNumber"
								[(ngModel)]="paymentProfile.fw1__Bank_ABA_Code__c"
								[formControl]="bankingRoutingNumberControl"
								mask="999999999"
								styleClass="w-100"
							></p-inputMask>
							<label for="bankingInformationRoutingNumber">Bank Routing Number</label>
						</span>
						<div class="x-small text-center">
							Routing number can be found on your bank account website or at the bottom of your bank checks. Typically towards the left. It is
							always 9 digits.
						</div>
					</div>
					<div class="p-col-12 p-md-6">
						<span class="p-float-label mt-4">
							<input
								pInputText
								#bankingInformationAccountNumber
								name="bankingInformationAccountNumber"
								type="text"
								[(ngModel)]="paymentProfile.fw1__Bank_Account_Number__c"
								[formControl]="bankingAccountNumberControl"
								class="w-100"
							/>
							<label for="bankingInformationAccountNumber">Bank Account Number</label>
						</span>
						<div class="item-med" *ngIf="bankingAccountNumberControl.hasError">
							<div class="text-danger" *ngIf="bankingAccountNumberControl.hasError('notANumber')">
								Account number must be a number and not have letters or special characters.
							</div>
							<div
								class="text-danger"
								*ngIf="bankingAccountNumberControl.hasError('minlength') || bankingAccountNumberControl.hasError('maxlength')"
							>
								Account number should be between 7 and 17 digits long
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="card m-4">
			<form #authorizationForm="ngForm">
				<div class="d-flex">
					<div class="display-6 ms-1 mt-2 mb-1"></div>
				</div>
				<p-divider></p-divider>
				<div class="d-flex flex-column">
					<div class="d-flex ms-4">
						<p-checkbox
							required="true"
							binary="true"
							name="termsAcceptanceAccept"
							[(ngModel)]="paymentProfile.Accepted_Terms_Online__c"
						></p-checkbox>
						<div class="item-med ms-3">
							I authorize Focus POS of Arizona, llc to debit the bank account information provided above for all contracted services and
							incidental purchases authorized by my company. I understand that I am entering into a contractual agreement with Focus POS of
							Arizona, llc and agree the terms if the
							<a
								href="https://focusca.my.salesforce.com/sfc/p/G0000000kkO8/a/4600000002rP/E0I19YCgoYPDbTwTw55OlWTYKWxTEjUT7czP2tIY6ys"
								target="_blank"
								>Master Subscription Agreement</a
							>
							and
							<a
								href="https://focusca.my.salesforce.com/sfc/p/G0000000kkO8/a/4600000002tz/zYmFNfF728Vnw_ANrlZ.i7uN9NlX4Mvhbm0W90geYI4"
								target="_blank"
							>
								General Terms & Conditions of Sale</a
							>
						</div>
					</div>
					<div class="p-grid">
						<div class="p-col-12 p-md-6">
							<span class="p-float-label mt-4">
								<input
									pInputText
									required="true"
									#profileCompletedByFirstName
									name="profileCompletedByFirstName"
									type="text"
									[(ngModel)]="profileCompletedBy.firstName"
									class="w-100"
								/>
								<label for="profileCompletedByFirstNam">First name</label>
							</span>
						</div>
						<div class="p-col-12 p-md-6">
							<span class="p-float-label mt-4">
								<input
									pInputText
									required="true"
									#profileCompletedByLastName
									name="profileCompletedByLastName"
									type="text"
									[(ngModel)]="profileCompletedBy.lastName"
									class="w-100"
								/>
								<label for="profileCompletedByLastName">Last name</label>
							</span>
						</div>
					</div>
					<div class="p-grid">
						<div class="p-col-12 p-md-6">
							<span class="p-float-label mt-4">
								<input
									pInputText
									required="true"
									#profileCompletedByTitle
									name="profileCompletedByTitle"
									type="text"
									[(ngModel)]="profileCompletedBy.title"
									class="w-100"
								/>
								<label for="profileCompletedByTitle">Title</label>
							</span>
						</div>
						<div class="p-col-12 p-md-6 d-flex">
							<div class="my-auto">Authorized at {{ app.moment().format("l LT") }}</div>
						</div>
					</div>
				</div>
				<div class="d-flex w-100">
					<div class="d-flex mx-auto">
						<p-button
							[disabled]="billingContactForm.invalid || bankingInformationForm.invalid || authorizationForm.invalid"
							pRipple
							styleClass="p-button-raised p-button-success my-2"
							(click)="submit()"
						>
							<ng-template pTemplate="content">
								<div class="d-flex justify-content-center">
									<fa-icon [icon]="['fad', 'check-double']" size="lg" class="ms-1 me-2"></fa-icon>
									Save Profile
								</div>
							</ng-template>
						</p-button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>

<p-overlayPanel #bankingInfoDisclaimer>
	<div class="d-flex flex-column item-med">
		<span class="bold">Why can't I pay with a credit card?</span>
		<span class="italic"
			>Sadly over the past several years, some unscrupulous business owners have decided to breach their contracts with Focus and commit credit card fraud
			by either willfully disputing charges while still demanding services or cancel their credit card without notifying Focus of the new card
			information. This has resulted in a huge loss of revenue for Focus with no reasonable solution. We have not raised our prices to our customers in
			over 10 years, and want to continue to offer the same reasonable priced solution, therefore we respectfully request that all payments be made via
			ACH.</span
		>
	</div>
</p-overlayPanel>
